export default __webpack_public_path__ + "static/media/4.ba1fa4a4.png";